export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4614.9478694c.jpg";